/**
 *
 * 挂载在浏览器上的cookie\localStorage\window等全局对象的命名空间
 * 在此处统一定义，以免冲突
 * @Author: xcp
 *
 * * Date         Version Remarks
 * ============ ======= ======================================================
 * 2016/4/26      2.0     xcp      Second version
 * 2023/01/05      3.0     FJJ     同步essaone平台逻辑迁移到此
 *
 * Copyright 2019, all rights reserved. Essa.cn
 */

export default {
    // react 组件数据，挂在window对象上
    REACT_COMPONENTS_DATA: 'REACT_COMPONENTS_DATA',
    // 组件数据写入时，确认组件数据对象是否存在的函数
    REACT_COMPONENTS_DATA_ENSURE: 'REACT_COMPONENTS_DATA_ENSURE',
    // 本地搜索历史，写在 locationStorage\userData\Cookie上
    LOCAL_SEARCH_HISTORY: 'LOCAL_SEARCH_HISTORY',
    // 视图数据，服务端渲染时，将服务端数据写入html，以免二次请求
    VIEW_MODEL_DATA: 'VIEW_MODEL_DATA'
};
